<template>
  <div style="width: 100%;height: 100%;box-sizing: border-box" :style="{
    textAlign: option.attribute.textAlign, fontSize: option.attribute.textSize + 'px',
    color: textColor, backgroundColor: bgColor, backgroundImage: gradualColor,
    '-webkit-background-clip': bgClip,
    fontStyle: option.attribute.fontStyle, fontWeight: option.attribute.fontWeight, lineHeight: option.attribute.textLineHeight + 'px',
    letterSpacing: option.attribute.letterSpacing + 'px', borderRadius: option.attribute.borderRadius + '%',
    borderStyle: option.attribute.borderStyle, borderWidth: option.attribute.borderWidth + 'px', borderColor: option.attribute.borderColor,
    fontFamily: option.attribute.textFamily, textDecoration: option.attribute.textDecoration
  }" @click="clickHandler">
    {{ cptData?.value }}
  </div>
</template>

<script>
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { CommonFuncCalculate } from '@/utils/func.js';
import cptTextOption from "@/components/element/attrs/cpt-text-option";
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-total",
  props: { option: Object ,components: Array, current: Object},
  // mixins: [mixinsCom], 
  computed: {
    bgColor() {
      if (this.alarmed) {
        return this.option.attribute.alarmConfig.bgColor
      } else {
        return this.option.attribute.enableGradual === 1 ? this.option.attribute.bgColor : 'transparent'
      }
    },
    textColor() {
      if (this.alarmed) {
        return this.option.attribute.alarmConfig.textColor
      } else {
        return this.option.attribute.enableGradual === 1 ? this.option.attribute.textColor : 'transparent'
      }
    },
    gradualColor() {
      if (this.option.attribute.enableGradual === 1 || this.alarmed) {
        return ''
      } else if (this.option.attribute.enableGradual === 2) {//从左到右
        return 'linear-gradient(to right, ' + this.option.attribute.gradualColor.toString() + ')'
      }
      return 'linear-gradient(to bottom, ' + this.option.attribute.gradualColor.toString() + ')'//从上到下
    },
    bgClip() {
      if (this.alarmed) {
        return null
      }
      return this.option.attribute.enableGradual === 1 ? null : 'text'
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },

  data() {
    return {
      cptData: { value: '合计' },
      uuid: null,
      alarmed: false,
      jsFunFlag: false,
      sourceData: []
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
    const temp = JSON.parse(JSON.stringify(cptTextOption.attribute))
    this.option.attribute = Object.assign({}, temp, this.option.attribute);
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }

  },
  watch: {
    'option.attribute.functionResult': {
      handler() {
        this.calculateValue()
      },
      deep: true
    },
    'option.cptDataForm.functionVariable': {
      handler() {
        this.calculateValue()
      },
      deep: true
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        const defaultValue = getDefaultValue(this.option.attribute)
        if (defaultValue) {
          this.cptData.value = defaultValue
          // this.cptData = { value: defaultValue }
        } else {
          // this.loadData(cptDataForm, paras)
          console.log("/?????asiudhaus89hdasu8daus8dshu9duh9dsu9aduh9ashu9dsad")
          this.setFunctionVariable(paras)
        }
      },this.components)
    },
    // loadData(cptDataForm, paras) {
    // let isSql = cptDataForm.datasetId?.split(',')
    // if (isSql.length > 0) {
    //   return
    // }
    // getDataJson(cptDataForm, paras, (res) => {
    //   // if (this.isDataSource(cptDataForm, res)) {
    //   //   this.jsFunFlag = res.jsFunction
    //   //   // this.setFunctionVariable(cptDataForm, res.resStr[0], count)
    //   // } else {

    //   // }
    //   this.jsFunFlag = false
    //   this.cptData.value = res.value
    // })
    // },
    isSql() {
      let isSql = this.option.cptDataForm.datasetId?.split(',')
      return isSql.length
    },
    isDataSource(cptDataForm, res) {
      return cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction')
    },
    // setFunctionVariable(dataForm, variableObject, count) {
    //   for (const key in variableObject) {
    //     let object = {
    //       field: key,
    //       value: variableObject[key]
    //     }
    //     dataForm.functionVariable[count].children.push(object)
    //   }
    // },
    clickHandler() {
      this.$emit("clickHandler", this.option.interaction, 'default', this.cptData.value, 'cpt-total')
    },
    // 计算
    calculateValue() {
      if (!this.isSql()) {
        return
      }

      const { functionResult } = this.option.attribute
      const { functionVariable } = this.option.cptDataForm

      if (!functionResult.function.length) {
        this.cptData.value = '合计'
        return
      }
      
      const { result } = CommonFuncCalculate.init(functionResult.function, functionVariable)
      
      console.log('hgagagagagag', result)
      this.cptData.value = result === 'error' ? '' : result
      // this.cptData = result === 'error' ? {value: ''} : {value: result}
    },
    // 重组数据集变量
    async setFunctionVariable(paras) {
      // 重组数据集
      let sqlList = []

      // 组合dataForm
      const { cptDataForm } = this.option
      const datasetIds = cptDataForm.datasetId.split(',').filter(x => x)

      if (!datasetIds.length) {
        return
      }

      let resetDataForm = datasetIds.map(id => ({
        ...cptDataForm,
        datasetId: id
      }))
      // 重组
      for (let i = 0; i < resetDataForm.length; i++) {
        const result = await this.getSqlJson(resetDataForm[i],paras)
        console.log(result, 'resultresultresult')
        let object = {
          name: cptDataForm.datasetName[i], // 获取数据集名称      
          children: result
        }

        sqlList.push(object)
      }
      console.log(sqlList, 'sqlListsqlListsqlList')
      this.option.cptDataForm.functionVariable = sqlList
    },
    getSqlJson(dataForm,paras) {
      return new Promise((resolve) => {
        getDataJson(dataForm, paras, res => {
          console.log(res, 'getDataJson')
          const resetResult = []
          if (res.resStr) {
            if (Array.isArray(res.resStr)) {
              const item = res.resStr[0];
              for (const key in item) {
                let numbers = []
                if (typeof item[key] === 'number') {
                  numbers = res.resStr.map(x => x[key])
                }
                resetResult.push({
                  field: key,
                  value: numbers
                })
              }
            } else {
              for (let i = 0; i < res.resStr.length; i++) {
                const item = res.resStr[i];
                for (const key in item) {
                  resetResult.push({
                    field: key,
                    value: item[key]
                  })
                }
              }
            }
          }
          resolve(resetResult)
        })
      })
    },
    setValue(value) {
      this.cptData.value = value
    },
    getValue() {
      return this.cptData.value
    }
  },
}
</script>

<style scoped></style>
